<template>
    <div class="faq">
        <nuxt-link to="/pomosh-klientam/" v-if="$device.isMobile" class="sm-title page__title">
            <div>{{ $t("faq") }}</div>
            <span class="return-btn">
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.25 1.25L0.75 5.75L5.25 10.25" stroke="black" />
                </svg>
            </span>
        </nuxt-link>

        <div class="faq__content">
            <OpenBlock :q="item.question" v-for="(item, index) in faq" :key="index">
                <template>
                    <div v-html="item.answer"></div>
                </template>
            </OpenBlock>
        </div>
    </div>
</template>

<script>
import OpenBlock from "~/components/OpenBlock";
import { mapGetters } from "vuex";
export default {
    layout: "help",
    name: "faq",
    components: { OpenBlock },
    head() {
        return {
            title: "FAQ | " + this.$i18n.t("pps_title"),
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.$root.context.app.i18n.t("faq_text"),
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.$root.context.app.i18n.t("faq_text"),
                },
            ],
        };
    },
    async asyncData({ $axios, app }) {
        const faq = await $axios.get("/api/pages/faq");
        const data = {
            faq: faq.data.data.faq,
            crumbs: [
                {
                    name: app.i18n.t("customer_help"),
                },
                { name: app.i18n.t("faq") },
            ],
        };
        return data;
    },
    watch: {
        async locale() {
            await this.$nuxt.refresh();
            this.$store.commit("crumbs/change", this.crumbs);
        },
    },
    computed: {
        ...mapGetters({
            locale: "globalvars/getLang",
        }),
    },
    mounted() {
        this.$store.commit("crumbs/change", this.crumbs);
    },
};
</script>

<style lang="less">
.faq {
    // @media screen and (max-width: 830px) {
    //     margin-top: -36px;
    // }
    &__content {
        @media screen and (max-width: 830px) {
            padding-top: 35px;
        }
    }
}
</style>
